import { Component, OnChanges, OnInit, Input } from '@angular/core';
import { Group, Client } from 'core/index';
import { EmailsListService } from '../../../emails/services/email-list.service';

@Component({
  selector: 'lms-group-notifications',
  templateUrl: './group-notifications.component.html',
  styleUrls: ['./group-notifications.component.scss'],
  providers: [EmailsListService]
})
export class GroupNotificationsComponent implements OnInit, OnChanges {
  @Input() group: Group;
  @Input() client: Client;
  public groupEmailsListId = 'GROUP_EMAILS_LIST';
  public filters: Object;
  public toolbarConfig: any;
  public timezone: any;

  constructor() {}

  public ngOnInit() {
    this.toolbarConfig = {
      list: {
        listId: this.groupEmailsListId,
        download: true,
        filterRow: false,
        columnChooser: false,
        hideSearch: false,
        skeletor: true
      }
    };
    this.timezone = this.client.timezone;
  }

  public ngOnChanges() {
    if (this.group) {
      this.filters = { groupId: this.group.id };
    }
  }

  /**
   * Set the toolbar of table
   * @param hideSearch
   */
  public setToolbarTable(hideSearch: boolean): void {
    this.toolbarConfig = {
      ...this.toolbarConfig,
      list: {
        ...this.toolbarConfig.list,
        download: !hideSearch,
        hideSearch: hideSearch,
        hideItemsSelector: hideSearch
      }
    };
  }
}
